import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ApiStatus } from "services/common"

interface CaptureBookingExtensionResponse extends AxiosResponse {
  data: {
    data: boolean
    message: string
    apiStatus: ApiStatus
  }
}

export interface CaptureBookingExtensionRequest
  extends Partial<AxiosRequestConfig> {
  bookingNumber: string
}

export function captureBookingExtensionApi(
  { bookingNumber, ...config }: CaptureBookingExtensionRequest,
  axiosInstance: AxiosInstance,
): Promise<CaptureBookingExtensionResponse> {
  return axiosInstance({
    method: "get",
    url: `/booking/auto-capture-booking-extension?bookingNo=${bookingNumber}`,
    ...config,
  }) as Promise<CaptureBookingExtensionResponse>
}
